export default __webpack_public_path__ + "static/media/r4.4919fc1f.jpg";